import { NBSP } from '../../../../../../shared/constants/symbols';
import { plural } from '@cian/utils';

const DICTIONARY = {
  top3: ['Топ', 'Топа', 'Топов'],
  premium: ['Премиум', 'Премиума', 'Премиумов'],
  paid: ['Платное', 'Платных', 'Платных'],
};

export const getMobileServiceName = service => {
  const { count, services } = service;

  const serviceName = services.join('+');
  const dict = DICTIONARY[serviceName];

  return `${count}${NBSP}${plural(count, dict)}`;
};
